<div class="dialog-container">

  <div class="filter-content">
    <form [formGroup]="filterForm" (keydown.enter)="onApply()">
      <div>
        <mat-form-field appearance="outline" class="slim-width">
          <!-- <mat-label>Filters</mat-label> -->
          <mat-select placeholder="Select Filter" formControlName="filter">
            <mat-select-trigger>
              <ng-container *ngIf="filterForm.get('filter')?.value === 'RAG'; else defaultLabel">
                RAG
                <span *ngIf="filterForm.get('Red')?.value">Red </span>
                <span *ngIf="filterForm.get('Grey')?.value">Grey </span>
                <span *ngIf="filterForm.get('Amber')?.value">Amber </span>
                 <span *ngIf="filterForm.get('Green')?.value">Green </span>
              </ng-container>
              <ng-template #defaultLabel>
                {{ filterForm.get('filter')?.value }}
              </ng-template>
            </mat-select-trigger>

            <mat-option class="fw-light" value="Client Name">Client Name</mat-option>
            <mat-option class="fw-light" *ngIf="!isGroup" value="Review Date">Review Date</mat-option>
            <mat-option class="fw-light" *ngIf="!isGroup" value="RAG">RAG</mat-option>
            <mat-option class="fw-light" *ngIf="!isGroup" value="Group Name">Group Name</mat-option>
            <mat-option class="fw-light" *ngIf="!isGroup" value="Status">Status</mat-option>
            <mat-option class="fw-light" value="Household Name"> Household Name</mat-option>

          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filterForm.get('filter')?.value === 'Review Date'">
        <mat-form-field appearance="outline" class="slim-width">
          <input matInput formControlName="search" [matDatepicker]="picker" placeholder="Select Date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
        <div *ngIf="filterForm.get('filter')?.value === 'Status'">
        <mat-form-field appearance="outline" class="slim-width">
          <mat-select placeholder="Select Status" formControlName="search">
            <mat-option [value]="workflowStatus.DRAFT">Draft</mat-option>
            <mat-option [value]="workflowStatus.DBDREVIEW">DS Review</mat-option>
            <mat-option [value]="workflowStatus.AMLREVIEW">AML Review</mat-option>
            <!-- <mat-option [value]="workflowStatus.SUBMITTED">Submitted</mat-option> -->
            <mat-option [value]="workflowStatus.RETURNEDBM">Returned by DS</mat-option>
            <mat-option [value]="workflowStatus.RETURNEDAML">Returned by AML</mat-option>
            <!-- <mat-option [value]="workflowStatus.RESUBMITTED">Resubmitted</mat-option> -->
            <mat-option [value]="workflowStatus.CLOSED">Closed</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        *ngIf="filterForm.get('filter')?.value !== 'Review Date' && filterForm.get('filter')?.value !== 'RAG' && filterForm.get('filter')?.value !== 'Status'">
        <mat-form-field appearance="outline" class="slim-width">
          <input matInput formControlName="search" placeholder="Search">
        </mat-form-field>
      </div>

      <div *ngIf="filterForm.get('filter')?.value === 'RAG'" class="checkbox-group">
       <mat-checkbox [formControl]="Red" ><span class="red">Red</span></mat-checkbox>
<mat-checkbox [formControl]="Grey"><span class="gray">Grey</span></mat-checkbox>
<mat-checkbox [formControl]="Amber"><span class="amber">Amber</span></mat-checkbox>
<mat-checkbox [formControl]="Green"><span class="green">Green</span> </mat-checkbox>
      </div>
      <div class="menu-actions">
        <button mat-stroked-button color="warn" class="amlbuttonbackgroundnoborder" type="button" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" class="amlbuttonbackground" type="button" (click)="onApply()">Apply</button>
      </div>
    </form>
  </div>
</div>